import { render, staticRenderFns } from "./vertical-tabs-component.vue?vue&type=template&id=b35f3a3a&scoped=true&"
import script from "./vertical-tabs-component.vue?vue&type=script&lang=ts&"
export * from "./vertical-tabs-component.vue?vue&type=script&lang=ts&"
import style0 from "./vertical-tabs-component.vue?vue&type=style&index=0&id=b35f3a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35f3a3a",
  null
  
)

export default component.exports